import React from 'react';
import { Instagram, Heart, Play } from 'lucide-react';
import { SOCIAL, CONTACT } from '../lib/butterstone';

const Card = ({ img, type }) => (
  <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="relative flex-shrink-0 w-52 h-64 md:w-60 md:h-72 rounded-xl overflow-hidden group">
    <img src={img} alt="Butterstone on Instagram" loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#1E3226]/60 to-transparent" />
    <span className="absolute top-3 right-3 text-white">{type === 'reel' ? <Play size={18} /> : <Heart size={18} />}</span>
    <span className="absolute bottom-3 left-3 text-white text-[11px] tracking-widest uppercase">{type}</span>
  </a>
);

const SocialMarquee = () => {
  const row = [...SOCIAL, ...SOCIAL];
  return (
    <section className="py-16 md:py-20 bg-[#EAF0E4] overflow-hidden" data-testid="social-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
        <div>
          <span className="overline">Follow the journey</span>
          <h2 className="font-serif text-4xl md:text-5xl mt-3">@butterstone.sakleshpur</h2>
        </div>
        <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="btn-moss self-start sm:self-auto" data-testid="instagram-cta"><Instagram size={16} /> Follow on Instagram</a>
      </div>
      <div className="relative">
        <div className="flex gap-4 w-max animate-marquee marquee-pause">
          {row.map((s, i) => <Card key={i} {...s} />)}
        </div>
      </div>
    </section>
  );
};

export default SocialMarquee;
